"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toArray;

function toArray(value) {
  return value == null ? [] : [].concat(value);
}


//////////////////
// WEBPACK FOOTER
// ./~/yup/lib/util/toArray.js
// module id = 537
// module chunks = 0